/**
 * Interceptor for tracking progress of POST requests.
 */

import { Injectable } from "@angular/core";
import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { SendingProgressUpdateService } from "../../services/sending-progress-update.service";

@Injectable()
export class SendingProgressInterceptor implements HttpInterceptor {

  constructor(private progressUpdateService: SendingProgressUpdateService) {
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.method.toUpperCase() !== "POST") {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event.type === HttpEventType.UploadProgress && event.total) {
          const progress = Math.round((100 * event.loaded) / event.total);
          this.progressUpdateService.emitProgressUpdate(progress);
        }
      }),
    );
  }
}
